<template>
  <div class=" w-full ">
    <div class=" relative  w-full">
      <input
      v-if="seleccionado==null"
        id="search"
        v-model="search"
        type="text"
        :placeholder="'Buscar '+label+'...'"
        class="p-2  w-full border border-gray-300 rounded"
        @input="buscarP(search)"
        @focus="handleDropdownEnter"
        @blur="handleDropdownLeave"
      >

      <ul
        v-if="searchData.length || isDropdownFocused"
        class="w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-50 max-h-60 overflow-y-auto shadow-lg"
        @mouseenter="handleDropdownEnter"
        @mouseleave="handleDropdownLeave"
      >
        <li class="px-1 pt-1 pb-2 font-bold border-b border-gray-200">
          Mostrando {{ searchData.length }} de {{ Array.isArray(rows) ? rows.length : 0 }} elementos
        </li>
        <li
          v-for="sel in searchData"
          :key="sel.id || sel.nombre"
          class="cursor-pointer hover:bg-gray-100 p-1 z-50 rounded"
          @click="selectRow(sel)"
          @mousedown.prevent="selectRow(sel)"
        >
          <div class=" w-full flex  flex-wrap justify-start overflow-x-hidden">
            <span class="text-xs font-extrabold text-blue-900 w-full"> {{sel.name}} {{sel.apellido_p}} {{sel.apellido_m}}/{{sel.phone}}</span>
          
          </div>
        </li>
      </ul>

      <div
        v-if="seleccionado"
        @click="selectRow(null)"
        class="font-extrabold pt-1 text-start w-full justify-start flex text-xs px-2"
      >

      <!--{{ CapitalizeTo(label) }} seleccionado--> <span class="font-semibold text-blue-500 text-start text-base"> : {{ seleccionado.hasOwnProperty('nombre')?seleccionado.nombre:seleccionado.name+' '+seleccionado.apellido_p+' '+seleccionado.apellido_m+' '+seleccionado.email+' '+seleccionado.phone }} 
        <i class="text-3xl las la-window-close"></i>
      </span>
      </div>
    </div>
  </div>
</template>

<script>
import generales from '@/functions/generales'
import {
    ref,
    computed,
    defineEmits
} from 'vue'
 //import { defineProps, useContext } from 'vue'
   
export default {
    mixins:[generales],
    props: {
       
        rows: {
            type: Array,

        },
        label: {
            type: String,
            default:''

        },
        valor:{
            type:Object
        }
    },
    //emits:'seleccionado',
    setup(props,{ emit }) {
      //let emit  = defineEmits(['seleccionado'])
        let search = ref('')
        let isDropdownFocused = ref(false)
        
        const searchData = computed(() => {
            // Mostrar resultados solo cuando hay texto de búsqueda
            if (search.value === '' || search.value.length < 1) {
                return []
            }
           
            // Devolver todos los resultados que vienen de la API sin filtrar
            if(props.rows && Array.isArray(props.rows) && props.rows.length > 0){
                console.log('🔍 Búsqueda:', search.value);
                console.log('📋 Datos de API:', props.rows);
                console.log('✅ Mostrando todos los resultados de la API');
                
                return props.rows; // Sin filtro ni límite
            } else {
                console.log('❌ No hay datos o no es array:', props.rows);
                return [];
            }
           
        });
        const buscarP = (palabra) => {
           
           //search.value = ''
            emit("carga", palabra)
       }
        const selectRow = (country) => {
            seleccionado.value = country
            search.value = ''
            isDropdownFocused.value = false
             emit("seleccionado", seleccionado)
        }
        
        const handleDropdownEnter = () => {
            isDropdownFocused.value = true
        }
        
        const handleDropdownLeave = () => {
            setTimeout(() => {
                isDropdownFocused.value = false
            }, 200)
        }
        
        let seleccionado = ref(props.valor)
        return {
           emit,
            search,
            searchData,
            buscarP,
            selectRow,
            seleccionado,
            isDropdownFocused,
            handleDropdownEnter,
            handleDropdownLeave
        }
    },
    mounted(){

    }
}
</script>
